
import { defineComponent } from 'vue'

// presentation information
interface PresentationInfo {
  title: string,
  author: string,
  conference: string,
  location: string,
  date: string,
  number?: string,
  note?: string
}

export default defineComponent({
  data () {
    return {
      presentations: [
        {
          title: 'キタエフ鎖を用いたSNS接合系における分数ジョセフソン効果の増強',
          author: '<u>角田 峻太郎</u>、古崎 昭',
          conference: '創発量子現象のフロンティア：超伝導接合、エッジ伝導、エニオン',
          location: '京都大学基礎物理学研究所',
          date: '2024年5月',
          number: '3'
        },
        {
          title: 'κ系有機導体の磁気八極子秩序に誘起されるFFLO超伝導',
          author: '<u>角田 峻太郎</u>、中 惇、妹尾 仁嗣',
          conference: 'アシンメトリ量子物質の開発 〜現状と展望〜',
          location: '九州工業大学',
          date: '2024年1月',
          number: 'P11'
        },
        {
          title: '一軸性カイラル反強磁性鎖における量子効果',
          author: '<u>角田 峻太郎</u>、田中 秋広、加藤 雄介',
          conference: '日本物理学会 2023年春季大会',
          location: 'オンライン開催(Zoom)',
          date: '2023年3月',
          number: '23pPSC-17'
        },
        {
          title: '超伝導電流に誘起されるWeyl超伝導',
          author: '<u>角田 峻太郎</u>、高三 和晃',
          conference: '非自明な電子状態が生み出す超伝導現象の最前線：新たな挑戦と展望',
          location: '京都大学基礎物理学研究所',
          date: '2021年12月',
          number: 'PS-12'
        },
        {
          title: 'キタエフ鎖を用いたSNS接合における格子系特有のフェルミオンパリティ反転',
          author: '<u>角田 峻太郎</u>、古崎 昭',
          conference: '日本物理学会 第76回年次大会',
          location: 'オンライン開催(Zoom)',
          date: '2021年3月',
          number: 'PSD-10'
        },
        {
          title: '波数基底の多極子揺らぎに誘起される超伝導ペアリングの分類',
          author: '<u>角田 峻太郎</u>、栁瀬 陽一',
          conference: '「J-Physics: 多極子伝導系の物理」令和元年度領域全体会議',
          location: '神戸大学',
          date: '2020年1月',
          number: 'P04'
        },
        {
          title: 'クラスター磁気多極子揺らぎに媒介される超伝導機構',
          author: '<u>角田 峻太郎</u>、栁瀬 陽一',
          conference: '日本物理学会 2019年秋季大会',
          location: '岐阜大学',
          date: '2019年9月',
          number: '11pPSA-47'
        },
        {
          title: '高対称線上におけるトポロジカル結晶超伝導ノードの分類',
          author: '<u>角田 峻太郎</u>、野本 拓也、塩崎 謙、栁瀬 陽一',
          conference: '「トポロジーが紡ぐ物質科学のフロンティア」第4回領域研究会',
          location: '名古屋大学',
          date: '2019年1月',
          number: 'PB-33'
        },
        {
          title: '奇パリティ磁気多極子揺らぎに誘起される超伝導',
          author: '<u>角田 峻太郎</u>、栁瀬 陽一',
          conference: '日本物理学会 2018年秋季大会',
          location: '同志社大学',
          date: '2018年9月',
          number: '10pPSB-81'
        },
        {
          title: '空間群対称性に守られた非自明超伝導ギャップ構造',
          author: '<u>角田 峻太郎</u>、栁瀬 陽一',
          conference: '「J-Physics: 多極子伝導系の物理」平成30年度領域全体会議',
          location: '東北大学金属材料研究所',
          date: '2018年5月',
          number: 'P07'
        },
        {
          title: '角運動量j<sub>z</sub>に依存する超伝導ポイントノード — UPt<sub>3</sub>, UBe<sub>13</sub>, SrPtAsなどへの適用 —',
          author: '<u>角田 峻太郎</u>、栁瀬 陽一',
          conference: '「J-Physics: 多極子伝導系の物理」平成29年度領域全体会議',
          location: '東京大学物性研究所',
          date: '2018年3月',
          number: 'P12',
          note: '<b class="text-success">最優秀ポスター賞</b>'
        },
        {
          title: ' Multipole superconductivity in Sr<sub>2</sub>IrO<sub>4</sub>: Symmetry-protected nodal superconductivity and FFLO superconductivity',
          author: '<u>角田 峻太郎</u>、野本 拓也、栁瀬 陽一',
          conference: '第10回 物性科学領域横断研究会',
          location: '神戸大学',
          date: '2016年12月',
          number: '35'
        },
        {
          title: 'イリジウム酸化物における非共型対称性に守られたラインノードとFFLO超伝導',
          author: '<u>角田 峻太郎</u>、野本 拓也、栁瀬 陽一',
          conference: '超伝導研究の最先端：多自由度、非平衡、電子相関、トポロジー',
          location: '京都大学基礎物理学研究',
          date: '2016年10月',
          number: 'P07'
        },
        {
          title: '非共型結晶に対する超伝導対称性の分類',
          author: '<u>角田 峻太郎</u>、栁瀬 陽一',
          conference: '日本物理学会 2016年秋季大会',
          location: '金沢大学',
          date: '2016年9月',
          number: '15aPS-3'
        },
        {
          title: '磁気多極子秩序と共存する超伝導状態',
          author: '<u>角田 峻太郎</u>、栁瀬 陽一',
          conference: '「J-Physics: 多極子伝導系の物理」平成28年度領域全体会議',
          location: '北海道大学',
          date: '2016年5月',
          number: 'P48',
          note: '<b class="text-success">最優秀ポスター賞</b>'
        }
      ] as PresentationInfo[]
    }
  }
})
